import mapValues from 'lodash/mapValues';

export default function keyMirror<T extends Record<string, any>>(obj: T): { [K in keyof T]: K } {
  return mapValues(obj, (v, k) => k) as { [K in keyof T]: K };
}
